import type { GifConfig } from "../types";

interface GifPreviewProps {
  gif: GifConfig;
}

export function GifPreview({ gif }: GifPreviewProps) {
  return (
    <div className="overflow-hidden rounded-12 border border-stroke-soft-200 bg-bg-white-0">
      <div className="border-b border-stroke-soft-200 bg-bg-weak-50 px-3 py-2">
        <span className="text-label-xs font-medium text-text-soft-400">Preview</span>
      </div>
      <div className="p-3">
        <a href={gif.sourceUrl} target="_blank" rel="noopener noreferrer" className="block">
          <img
            src={gif.imageUrl}
            alt="Climate awareness GIF"
            className="h-auto w-full rounded-8"
            style={{ maxWidth: "250px" }}
          />
        </a>
        <a
          href={gif.sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 block text-paragraph-xs text-text-soft-400 hover:text-text-sub-600"
        >
          {gif.sourceText}
        </a>
      </div>
    </div>
  );
}
